<template>
    <ShcUiNotificationWrapper
        :is-show="show"
        width="lg:w-[31.75rem]"
        margin="lg:mr-5 xl:mr-1 2xl:mr-2"
        bg-color="bbk-claret"
        text-color="white"
    >
        <div class="h-14 flex items-center">
            <div class="flex grow items-center">
                <div
                    class="w-6 h-6 mx-4 flex flex-row justify-center items-center rounded-full border border-white bg-bbk-claret"
                    aria-hidden="true"
                >
                    <ShcUiIcon name="exclamation" />
                </div>
                <ShcUiParagraph v-if="content" :theme="PARAGRAPH_THEME.tertiary">
                    {{ content.message.toLowerCase() }}
                </ShcUiParagraph>
            </div>
            <ShcUiNotificationClose :auto-close="true" show @notification:close="onClose" />
        </div>
    </ShcUiNotificationWrapper>
</template>

<script setup lang="ts">
    import { PARAGRAPH_THEME } from '@shc/nuxt-shc-ui-layer/components/Paragraph/paragraph'
    import { NOTIFICATION_EVENT } from '~/components/Shc/Ui/Notification/notification'
    import type { Props } from '~/components/Shc/Ui/Notification/props'

    const props = defineProps<Props>()

    const emit = defineEmits<{
        (e: typeof NOTIFICATION_EVENT.notification_close, notificationMessage: { index: number }): void
    }>()

    const show = ref(true)

    function onClose(event: boolean) {
        show.value = event
        emit(NOTIFICATION_EVENT.notification_close, {
            index: props.id,
        })
    }
</script>
